<template>
  <div v-bind="$attrs" class="py-3">
    <div class="flex items-baseline justify-between">
      <strong class="font-semibold">
        {{ label }}
      </strong>
      <Link
        :href="route('checkout', { order, step })"
        class="text-blue-500 text-sm"
        text="Ändern"
      />
    </div>
    <div class="mt-1 text-gray-700 text-sm">
      <slot name="default">
        {{ text }}
      </slot>
    </div>
  </div>
</template>

<script>
import Link from 'Web/Shared/Link.vue';

export default {
  inheritAttrs: false,
  components: {
    Link,
  },
  props: {
    label: {
      type: String,
      required: true,
    },
    order: {
      type: Object,
      required: true,
    },
    text: {
      type: String,
      default: null,
    },
    step: {
      type: String,
      required: true,
    },
  }
}
</script>
